// import * as React from "react";
// import { useNavigate } from "react-router-dom";
// import { useEffect, useContext } from "react";
// import { DatosCompradorContext } from "../context/Context.js";
// import IconButton from "@mui/material/IconButton";
// import { ClipLoader } from "react-spinners";
// import PdfsTable from "../components/TableVisualizer.js";
// import Swal from "sweetalert2";
// import { styles } from "../theme/styles.js";
// import "../index.css";
// import axios from "axios";
// import { encodeData } from "../helpers/encode.js";
// function PDF2BUSCADOR(props) {
//   const {
//     correoCompradorContext,
//     setCorreoCompradorContext,
//     tiendaAsociadaContext,
//     setTiendaAsociadaContext,
//     rolContext,
//     setRolContext,
//     idGeneradoContext,
//     setIdGeneradoContext,
//     idbuscadoContext,
//     setIdbuscadoContext,
//   } = useContext(DatosCompradorContext);
//   const [pdfs, setPdfs] = React.useState();
//   const [spinnerAux, setSpinnerAux] = React.useState(true);
//   const [resetAux, setResetAux] = React.useState(false);
//   const [aux, setAux] = React.useState(false);
//   const [noFolio, setNoFolio] = React.useState("");
//   const [dataTable, setDataTable] = React.useState();
//   const navigate = useNavigate();

//   const findIndex = (arr, folio) => {
//     return arr.findIndex((item) => item.folio == folio);
//   };
//   useEffect(() => {
//     async function fetchPdfs() {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_BACK_APIVENTAANIMALES}/ventas/getAllFolios`,
//           {
//             headers: {
//               Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
//               apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         const pdfsJson = response.data.Folios;
//         setSpinnerAux(false);
//         setPdfs(pdfsJson);
//         setAux(false);
//         if (
//           pdfsJson.length == 0 ||
//           response.data.msg == "No Existen Folios Registrados"
//         ) {
//           setResetAux(true);
//         }
//       } catch (error) {
//         setSpinnerAux(false);
//       }
//     }
//     fetchPdfs();
//   }, []);
//   useEffect(() => {
//     // localStorage.removeItem("idGenerado");
//     // localStorage.removeItem("idBuscado");
//     setIdGeneradoContext("");
//     setIdbuscadoContext("");
//   }, []);
//   const separarFolio = (folio) => {
//     return folio
//       .replace(/(_)([A-Za-z])/g, (_, guion, letra) => {
//         return `_${letra}`;
//       })
//       .replace(/([A-Za-z])(\d)/g, (match, letra, digito) => {
//         return `${letra}_${digito}`;
//       });
//   };
//   function validateFolio(folio) {
//     const auxfolio = separarFolio(folio);
//     //quitar espacios
//     var aux2 = auxfolio.replace(/\s+/g, "");
//     const regex = /^\d{4}_[A-Z](_[A-Z]?\d{0,3}|\d{1,3})$/;
//     const regex2 = /^\d{4}_[A-Z]\d*(?!\w)/;
//     const aux3 = regex2.test(aux2);
//     return regex.test(aux2);
//   }
//   const formatoFolio = (folio) => {
//     return folio.replace(/([a-zA-Z])([0-9]+)/g, "$1_$2");
//   };
//   const quitarEspacios = (str) => {
//     return str.replace(/\s+/g, "");
//   };
//   return (
//     <div style={styles.content}>
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "space-around",
//         }}>
//         <h1
//           style={{
//             border: "none",
//             textAlign: "center",
//             fontSize: "1.3rem",
//             marginBottom: 0,
//             marginTop: "20px",
//             color: "#00205B",
//           }}>
//           Folios Registrados
//         </h1>
//         <div
//           style={{
//             border: "1px solid #ddd",
//             borderRadius: "25px",
//             padding: "1px",
//             display: "flex",
//             alignItems: "center",
//             width: "50%",
//             marginTop: "35px",
//             height: "40px",
//             marginBottom: "5px",
//             marginLeft: "auto",
//             marginRight: "auto",
//           }}>
//           <input
//             type="text"
//             maxLength={10}
//             textAlign="center"
//             placeholder="Ingresa un número de folio"
//             style={{
//               width: "100%",
//               padding: "10px",
//               fontSize: "16px",
//               border: "none",
//               outline: "none",
//               textAlign: "center",
//             }}
//             onChange={(e) => {
//               e.preventDefault();
//               //aplicar filtro dinamico y ajustar  const pdfs para que solo muestre los resultados filtrados
//             //si el inout esta vacio entonces
//               setNoFolio(e.target.value);
//             }}
//           />
//           <IconButton
//             style={{
//               backgroundColor: "#00205B",
//               color: "#fff",
//               padding: "10px",
//               borderRadius: "25px",
//               border: "none",
//               cursor: "pointer",
//               fontSize: "15px",
//             }}
//             onClick={async (e) => {
//               e.preventDefault();
//               var aux = formatoFolio(noFolio);
//               if (!validateFolio(noFolio)) {
//                 Swal.fire({
//                   title: "Error",
//                   text: "Ingresa un folio valido.",
//                   icon: "error",
//                   confirmButtonText: "Aceptar",
//                   iconColor: "red",
//                   confirmButtonColor: "00205B",
//                   confirmButtonColor: "#00205B",
//                 });
//                 return;
//               }
//               function buscarFolio(array, folioBuscado) {
//                 return array.some((obj) => obj.folio === folioBuscado);
//               }
//               const indice = findIndex(pdfs, formatoFolio(noFolio));
//               if (validateFolio(noFolio)) {
//                 if (!buscarFolio(pdfs, formatoFolio(noFolio))) {
//                   Swal.fire({
//                     title: "Error",
//                     text: "El folio ingresado no ha sido encontrado, favor de validarlo.",
//                     icon: "error",
//                     confirmButtonText: "Aceptar",
//                     iconColor: "red",
//                     confirmButtonColor: "#00205B",
//                   });
//                   return;
//                 } else {
//                   if (pdfs[indice].estatusContrato == "Incompleto") {
//                     Swal.fire({
//                       title: "Error",
//                       text: "El Folio tiene un estatus Incompleto.",
//                       icon: "error",
//                       confirmButtonText: "Aceptar",
//                       iconColor: "red",
//                       confirmButtonColor: "#00205B",
//                     });
//                     return;
//                   } else {
//                     if (validateFolio(aux)) {
//                       // setIdbuscadoContext(noFolio);
//                       encodeData("IDBUSCADO", noFolio);
//                       navigate("/pdfViewer2");
//                     }
//                   }
//                 }
//                 return;
//               }

//               if (!noFolio) {
//                 Swal.fire({
//                   title: "Error",
//                   text: "Favor De Ingresar Un Número De Folio.",
//                   icon: "error",
//                   confirmButtonText: "Aceptar",
//                   iconColor: "red",
//                   confirmButtonColor: "#00205B",
//                 });
//               }
//               if (!validateFolio(aux)) {
//                 Swal.fire({
//                   title: "Error",
//                   text: "Número De Folio Inválido",
//                   icon: "error",
//                   confirmButtonText: "Aceptar",
//                   iconColor: "red",
//                   confirmButtonColor: "00205B",
//                   confirmButtonColor: "#00205B",
//                 });
//               }
//             }}>
//             Buscar
//           </IconButton>
//         </div>
//         <div
//           style={{
//             display: "grid",
//             justifyContent: "center",
//             alignItems: "center",
//             height: "60vh",
//             marginTop: 0,
//             width: "100%",
//           }}>
//           <div
//             style={{
//               textAlign: "center",
//               marginTop: 0,
//               width: "90vw",
//             }}>
//             {!spinnerAux && !aux ? (
//               <PdfsTable pdfsV={pdfs}></PdfsTable>
//             ) : (
//               <ClipLoader color="#00205B" size="100px"></ClipLoader>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
// export default PDF2BUSCADOR;
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useEffect, useContext } from "react";
import { DatosCompradorContext } from "../context/Context.js";
import IconButton from "@mui/material/IconButton";
import { ClipLoader } from "react-spinners";
import PdfsTable from "../components/TableVisualizer.js";
import Swal from "sweetalert2";
import { styles } from "../theme/styles.js";
import "../index.css";
import axios from "axios";
import { encodeData } from "../helpers/encode.js";
function PDF2BUSCADOR(props) {
  const { setIdGeneradoContext, setIdbuscadoContext } = useContext(
    DatosCompradorContext
  );
  const [pdfs, setPdfs] = React.useState([]);
  const [filteredPdfs, setFilteredPdfs] = React.useState([]);
  const [spinnerAux, setSpinnerAux] = React.useState(true);
  const [noFolio, setNoFolio] = React.useState("");
  const navigate = useNavigate();
  const formatoFolio = (folio) => {
    return folio.replace(/([a-zA-Z])([0-9]+)/g, "$1_$2");
  };
  useEffect(() => {
    async function fetchPdfs() {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACK_APIVENTAANIMALES}/ventas/getAllFolios`,
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
              apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
              "Content-Type": "application/json",
            },
          }
        );
        const pdfsJson = response.data.Folios || [];
        setSpinnerAux(false);
        setPdfs(pdfsJson);
        setFilteredPdfs(pdfsJson); // Inicialmente muestra todos
      } catch (error) {
        setSpinnerAux(false);
      }
    }
    fetchPdfs();
  }, []);
  useEffect(() => {
    setIdGeneradoContext("");
    setIdbuscadoContext("");
  }, []);
  // const handleSearch = (input) => {
  //   setNoFolio(input);
  //   const filteredResults = pdfs.filter((pdf) =>
  //     pdf.folio.toLowerCase().includes(formatoFolio(input.toLowerCase()))
  //   );
  //   setFilteredPdfs(input ? filteredResults : pdfs); // Mostrar todos si está vacío
  // };
  const handleSearch = (input) => {
    setNoFolio(input);
    const formattedInput = input.toLowerCase();
    const filteredResults = pdfs.filter((pdf) => {
      // Filtrar por folio
      const folioMatch = pdf.folio
        .toLowerCase()
        .includes(formatoFolio(formattedInput));

      // Filtrar por estatusContrato
      const estatusMatch = pdf.estatusContrato
        ?.toLowerCase()
        .includes(formattedInput);

      // const estatusMatch = pdf.estatusContrato
      //   ?.toLowerCase()
      //   .includes(formattedInput);
      // Filtrar por especie
      const especieMatch = pdf.especie?.toLowerCase().includes(formattedInput);

      // Filtrar por fecha

      // let fechaFormateada = `${new Date(pdf.fechaRegistro).getDate()}/${
      let fechaFormateada = `${new Date(pdf.fechaRegistro).getDate()}/${
        new Date(pdf.fechaRegistro).getMonth() + 1
      }/${new Date(pdf.fechaRegistro).getFullYear()} ${new Date(
        pdf.fechaRegistro
      ).getHours()}:${String(new Date(pdf.fechaRegistro).getMinutes()).padStart(
        2,
        "0"
      )}`;

      let fechaMatch = fechaFormateada.includes(input);

      return folioMatch || estatusMatch || especieMatch || fechaMatch;
    });

    setFilteredPdfs(input ? filteredResults : pdfs);
  };

  return (
    <div style={styles.content}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-around",
        }}>
        <h1
          style={{
            border: "none",
            textAlign: "center",
            fontSize: "1.3rem",
            marginBottom: 0,
            marginTop: "20px",
            color: "#00205B",
          }}>
          Folios Registrados
        </h1>
        <div
          style={{
            border: "1px solid #ddd",
            borderRadius: "25px",
            padding: "1px",
            display: "flex",
            alignItems: "center",
            width: "50%",
            marginTop: "35px",
            height: "40px",
            marginBottom: "5px",
            marginLeft: "auto",
            marginRight: "auto",
          }}>
          <input
            type="text"
            maxLength={10}
            placeholder="Ingresa un número de folio"
            style={{
              width: "100%",
              padding: "10px",
              fontSize: "16px",
              border: "none",
              outline: "none",
              textAlign: "center",
            }}
            value={noFolio}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
        <div
          style={{
            display: "grid",
            justifyContent: "center",
            alignItems: "center",
            height: "60vh",
            marginTop: 0,
            width: "100%",
          }}>
          <div
            style={{
              textAlign: "center",
              marginTop: 0,
              width: "90vw",
            }}>
            {!spinnerAux ? (
              <PdfsTable pdfsV={filteredPdfs}></PdfsTable>
            ) : (
              <ClipLoader color="#00205B" size="100px"></ClipLoader>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PDF2BUSCADOR;
